import Cookies from 'js-cookie';

export default () => {
  try {
    return Cookies.get('token') || '';
  } catch {
    return '';
  }
};
